export default __webpack_public_path__ + "static/media/ceramol-acne-i-falsi-miti-da-sfatare.cb42b6ce.jpg";